import { Checkbox, Col, Flex, Form, Row } from 'antd';
import type { FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';
import ToggleSwitch from '@/components/ToggleSwitch';
import { isDarkModeEnabled as isDarkModeFeatureEnabled } from '@/utils/featureFlags';

interface SettingAppearanceProps {
  form: FormInstance;
}

const SettingAppearance = ({ form }: SettingAppearanceProps) => {
  const { t } = useTranslation('settings');
  const darkModeEnabled = Form.useWatch('dark_mode_enabled', form);

  // Hidden (rather than disabled) in builds where REACT_APP_ENABLE_DARK_MODE
  // is off (the UAT and prod workflows both turn it on), so this section -
  // and the ability to toggle the preference at all - only shows up where
  // the theme is offered.
  if (!isDarkModeFeatureEnabled()) return null;

  return (
    <div className='settings-appearance-wrapper'>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <p className='regional-section-heading'>
            {t('appearance', 'Appearance')}
          </p>
          <p className='regional-section-description mt-1'>
            {t(
              'appearanceDescription',
              'Choose how Zoomlogi looks on your device'
            )}
          </p>
        </Col>

        <Col span={24}>
          <Flex align='center' gap={12}>
            <ToggleSwitch
              alignLeft
              checked={!!darkModeEnabled}
              onChange={(e) =>
                form.setFieldsValue({ dark_mode_enabled: e.target.checked })
              }
            />
            <Form.Item
              name='dark_mode_enabled'
              valuePropName='checked'
              initialValue={false}
              hidden
            >
              <Checkbox />
            </Form.Item>
            <span
              style={{
                fontSize: 14,
                fontWeight: 600,
                lineHeight: '20px',
                color: 'var(--text-primary)',
              }}
            >
              {t('darkMode', 'Dark mode')}
            </span>
          </Flex>
        </Col>
      </Row>
    </div>
  );
};

export default SettingAppearance;
